
    <mat-card class="no-overflow full-width padding all margin all">
      <!-- Header -->
      <mat-card-header class="header-container">
        <mat-card-title>Key System Budget</mat-card-title>
        <div>
          <button mat-flat-button
            class="margin left bottom darkBackground"
            (click)="createTmk()"
            [disabled]="loading.isLoading || keySystem?.statusId === 14">
              <span *ngIf="!keySystem?.topMasterKey"> Create TMK </span>
              <span *ngIf="keySystem?.topMasterKey"> Update TMK </span>
            </button>

            <button class="link" *ngIf="hideSystemGenerateTMK === 'false'" [disabled]="keySystem?.statusId === 14" mat-icon-button [matMenuTriggerFor]="actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actions>
              <button mat-menu-item (click)="generateTmk({})"><mat-icon>computer</mat-icon>System Generate TMK</button>
            </mat-menu>
        </div>
        
      </mat-card-header>
      <mat-divider></mat-divider>
      <div class="custom-height">
        <lib-hierarchy
          *ngIf="keySystem?.masterKeysBudget"
          [masterKeys]="keySystem?.masterKeysBudget"
          [budgetHierarchy]="true"
          [keyways]="keyways"
          [keySystem]="keySystem"
          [structure]="structure"
          [heightOffset]="100"
          (deleteItemAction)="deleteItem($event)"
          (patchItemAction)="patchItem($event)"
          (addChildAction)="addChild($event)"
          [@fadeIn]
        >
        </lib-hierarchy>
      </div>
      
    </mat-card>

